import { FC } from "react";
import { AlertCircleIcon } from "lucide-react-native";

import {
  VnAlert,
  VnAlertDescription,
  VnAlertTitle,
} from "@/components/VnAlert";
import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnText } from "@/components/VnText/VnText";
import { envVariables } from "@/utils/envVariables";

// eslint-disable-next-line @typescript-eslint/naming-convention
const SHOULD_PRINT_ERROR =
  envVariables.EXPO_PUBLIC_ENVIRONMENT === "local" ||
  envVariables.EXPO_PUBLIC_ENVIRONMENT === "development";

type ErrorFallbackPropsType = {
  error: unknown;
  resetError: () => Promise<void>;
};

export const ErrorFallback: FC<ErrorFallbackPropsType> = ({
  error,
  resetError,
}) => {
  const errorMessage = error instanceof Error ? error.message : undefined;

  return (
    <VnBox className="flex-1 items-center justify-center px-4">
      <VnAlert variant="destructive" icon={AlertCircleIcon} className="w-full">
        <VnAlertTitle i18nKey="common:errorFallback.title" />
        <VnAlertDescription i18nKey="common:errorFallback.description" />
        <VnBox className="items-start gap-4 pt-2">
          {SHOULD_PRINT_ERROR && errorMessage && (
            <VnBox className="bg-primary w-full rounded-sm px-3 py-2">
              <VnText className="text-primary-foreground font-mono font-medium">
                {errorMessage}
              </VnText>
            </VnBox>
          )}
          <VnButton
            variant="outline"
            i18nKey="common:errorFallback.resetCta"
            className="text-foreground w-full shadow-none"
            onPress={() => {
              void resetError();
            }}
          />
        </VnBox>
      </VnAlert>
    </VnBox>
  );
};
